'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var _utils = require('./utils');

var _Spilit = require('./Spilit');

var _Spilit2 = _interopRequireDefault(_Spilit);

var _SuperScript = require('./SuperScript');

var _SuperScript2 = _interopRequireDefault(_SuperScript);

var _SubScript = require('./SubScript');

var _SubScript2 = _interopRequireDefault(_SubScript);

var _FontSize = require('./FontSize');

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontColor = require('./FontColor');

var _FontColor2 = _interopRequireDefault(_FontColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Bold = (0, _utils.inlineStyleComponentFactory)('bold'); // export this package's api

var Italic = (0, _utils.inlineStyleComponentFactory)('italic');
var Underline = (0, _utils.inlineStyleComponentFactory)('underline');
var StrikeThrough = (0, _utils.inlineStyleComponentFactory)('strikethrough');
var AlignLeft = (0, _utils.blockStyleComponentFactory)('align-left', { textAlign: 'left' });
var AlignRight = (0, _utils.blockStyleComponentFactory)('align-right', { textAlign: 'right' });
var AlignMiddle = (0, _utils.blockStyleComponentFactory)('align-middle', { textAlign: 'center' });
var AlignJustify = (0, _utils.blockStyleComponentFactory)('align-justify', { textAlign: 'justify' });
var EditorPluginBasicStyle = (0, _immutable.List)([_FontSize2["default"], _FontColor2["default"], Bold, Italic, _Spilit2["default"], Underline, StrikeThrough, _SuperScript2["default"], _SubScript2["default"], AlignLeft, AlignRight, AlignMiddle, AlignJustify]);
exports["default"] = EditorPluginBasicStyle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-basic-style@0.3.6@rc-editor-plugin-basic-style/lib/index.js
// module id = 113
// module chunks = 0 1 2